import type { DataTableColumnProps } from '~/shared/data-tables/DataTableColumn';

type BaseTotals = {
	sun: number;
	mon: number;
	tue: number;
	wed: number;
	thu: number;
	fri: number;
	sat: number;
	totalMissed?: number;
	totalMade?: number;
	totalRemaining?: number;
	total: number;
};

export const baseTotalColumns = <T extends BaseTotals>(): DataTableColumnProps<T>[] => [
	{ header: 'Sun', key: 'sun', sortable: true },
	{ header: 'Mon', key: 'mon', sortable: true },
	{ header: 'Tue', key: 'tue', sortable: true },
	{ header: 'Wed', key: 'wed', sortable: true },
	{ header: 'Thu', key: 'thu', sortable: true },
	{ header: 'Fri', key: 'fri', sortable: true },
	{ header: 'Sat', key: 'sat', sortable: true },
	{ header: 'Missed', key: 'totalMissed', sortable: true },
	{ header: 'Made', key: 'totalMade', sortable: true },
	{ header: 'Remaining', key: 'totalRemaining', sortable: true },
	{ header: 'Total', key: 'total', sortable: true }
];
